export const defaultDockerfileName = 'e2b.Dockerfile'
export const fallbackDockerfileName = 'Dockerfile'
